import { IFilterComboPropVerificacion } from "../../Interfaces/ListaVerificacion/PropiedadesVerificacion/IPropiedadesVerificacion";
import { fetchListVerificacion } from "../http-common";

const PostComboPropiedadesPorGrupo = (filter: IFilterComboPropVerificacion) => {
  return fetchListVerificacion.post(
    "PropiedadesVerificacion/ListarComboPorGrupoVerifiacion",
    filter
  );
};

const PropiedadesVerificacionService = {
  PostComboPropiedadesPorGrupo,
};
export default PropiedadesVerificacionService;
